import useLocalStorageState from "use-local-storage-state";
import { solutionMap } from "../data/solutionOptions.tsx";
import { SolutionMap } from "@labs/shared/types/Solution.ts";

export const useLocalSolutionMapState = () =>
  useLocalStorageState<SolutionMap>("solutionMap", {
    defaultValue: solutionMap,
  });
